<template>
  <v-flex d-flex>
    <v-layout wrap class="tiles" v-show="!isLoading">
      <v-flex
        xs6
        sm4
        md3
        lg2
        class="ma-0 pa-0"
        v-for="item in shafts"
        :key="item.id"
      >
        <ShaftGridCard
          :shaft="item"
          @itemClick="onItemClicked(item)"
          height="220"
        >
        </ShaftGridCard>
      </v-flex>
      <v-flex xs6 sm4 md3 lg2 class="ma-0 pa-0" v-if="showAdd">
        <v-card
          tile
          flat
          class="grey lighten-3 ma-3 d-flex flex-column align-center justify-center"
          height="220"
          @click="$emit('addClick', site)"
        >
          <v-icon x-large color="primary">mdi-plus-circle</v-icon>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap class="tiles" v-if="isLoading">
      <v-flex xs6 sm4 md3 lg2 class="ma-0 pa-0" v-for="n in 6" :key="n">
        <v-skeleton-loader
          class="ma-3"
          height="220"
          type="image"
          tile
        ></v-skeleton-loader>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import { mapActions } from 'vuex';
import ShaftGridCard from '@/components/ShaftGridCard.vue';

export default {
  name: 'ShaftGrid',
  components: { ShaftGridCard },
  props: ['shafts', 'site', 'showAdd', 'isLoading'],
  data: () => ({}),
  methods: {
    ...mapActions(['setCurrentShaft']),
    onItemClicked(item) {
      this.setCurrentShaft(item);
      this.$router.push('/schacht/' + item.id);
    },
  },
};
</script>
